import {
    createBaseThemeOptions,
    createUnifiedTheme,
    genPageTheme,
    palettes,
    shapes,
  } from '@backstage/theme';
  
  const baseThemeOptions = {
    fontFamily: 'Arial, sans-serif',
    defaultPageTheme: 'home',
    pageTheme: {
      home: genPageTheme({ colors: ['#987147', '#987147'], shape: shapes.round }),
      documentation: genPageTheme({ colors: ['#987147', '#987147'], shape: shapes.wave }),
      tool: genPageTheme({ colors: ['#987147', '#987147'], shape: shapes.wave }),
      service: genPageTheme({ colors: ['#987147', '#987147'], shape: shapes.wave }),
      website: genPageTheme({ colors: ['#987147', '#987147'], shape: shapes.wave }),
      library: genPageTheme({ colors: ['#987147', '#987147'], shape: shapes.wave }),
      other: genPageTheme({ colors: ['#987147', '#987147'], shape: shapes.wave }),
      app: genPageTheme({ colors: ['#987147', '#987147'], shape: shapes.wave }),
      apis: genPageTheme({ colors: ['#987147', '#987147'], shape: shapes.round }),
    },
  };
  
  // Funktion zur Erstellung eines Themes mit unterschiedlicher Palette
  const createHbTheme = (palette: typeof palettes.light | typeof palettes.dark) =>
    createUnifiedTheme({
      ...createBaseThemeOptions({ 
        palette: {
          ...palette,
          banner: {
            info: '#14b8a6',
            error: '#ef4444',
            warning: '#f59e0b',
            text: '#000000',
            link: '#ffffff',
          },
        }
      }),
      ...baseThemeOptions,
      components: {
        MuiButton: {
          styleOverrides: {
            root: {
              borderRadius: '8px', // Einheitliche Rundung
              textTransform: 'none', // Kein Großbuchstaben-Zwang
            },
            containedPrimary: {
              backgroundColor: '#987147', // Primärfarbe für gefüllte Buttons
              color: '#ffffff', // Textfarbe
              '&:hover': {
                backgroundColor: '#78543a', // Hover-Farbe
              },
            },
            containedSecondary: {
              backgroundColor: '#6B8E23', // Sekundärfarbe für gefüllte Buttons
              color: '#ffffff',
              '&:hover': {
                backgroundColor: '#556b1e', // Hover-Farbe
              },
            },
            outlinedPrimary: {
              borderColor: '#987147', // Rahmenfarbe
              color: '#987147',
              '&:hover': {
                backgroundColor: 'rgba(152, 113, 71, 0.1)', // Leichter Hintergrund beim Hover
              },
            },
          },
        },
        MuiSnackbarContent: {
          styleOverrides: {
            root: {
              backgroundColor: '#14b8a6',
              color: '#ffffff',
              borderRadius: '8px',
              '&.SnackbarContent-variantSuccess': {
                backgroundColor: '#14b8a6',
              },
              '&.SnackbarContent-variantError': {
                backgroundColor: '#ef4444',
              },
              '&.SnackbarContent-variantWarning': {
                backgroundColor: '#f59e0b',
              },
              '&.SnackbarContent-variantInfo': {
                backgroundColor: '#14b8a6',
              },
            },
            message: {
              color: '#ffffff',
            },
            action: {
              '& button': {
                color: '#ffffff',
              },
            },
          },
        },
        MuiAlert: {
          styleOverrides: {
            root: {
              borderRadius: '8px',
            },
            standardSuccess: {
              backgroundColor: '#14b8a6',
              color: '#ffffff',
              '& .MuiAlert-icon': {
                color: '#ffffff',
              },
            },
            standardError: {
              backgroundColor: '#ef4444',
              color: '#ffffff',
              '& .MuiAlert-icon': {
                color: '#ffffff',
              },
            },
            standardWarning: {
              backgroundColor: '#f59e0b',
              color: '#ffffff',
              '& .MuiAlert-icon': {
                color: '#ffffff',
              },
            },
            standardInfo: {
              backgroundColor: '#14b8a6',
              color: '#ffffff',
              '& .MuiAlert-icon': {
                color: '#ffffff',
              },
            },
          },
        },
      },
    });
  
  export const hbThemeLight = createHbTheme(palettes.light);
  export const hbThemeDark = createHbTheme(palettes.dark);
  